import { Checkbox } from 'baseui/checkbox';

export default Checkbox;
